import React, { useState, useEffect, useRef } from "react";
import DataTableListing from "../DataTableListing/DataTableListing";
import BackButton from "../BackButton/BackButton";
import "./Departments.css";
import sort from "../../assets/images/sort.png";
import search_bar from "../../assets/images/search.svg";
import ViewDepartment from "./ViewDepartment";
import { useAuth } from "../../features/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchDepartmentActions} from "../../state/actions/departmentActions";
import { useNavigate, useLocation } from "react-router";
import ResponsiveCardsDepartment from "./ResponsiveCardsDepartment";
import SearchComponent from "../SearchComponent/SearchComponent";

// Advisors Page
function Departments() {
   const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [openViewDepartments, setopenViewDepartments] = useState( !!location.state?.subjectId);

  const dispatch = useDispatch();
const {token} = useAuth()
 const sortRef = useRef(null);
  const { departments, loading, totalCount } = useSelector((state) => state.departmentData);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortValue, setSortValue] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState(
  location.state?.subjectId
    ? { subject_id: location.state.subjectId, subject_name: location.state.subjectName }
    : null);
  const [currentPage, setCurrentPage] = useState(1);
  const [debouncedSearch, setDebouncedSearch] = useState("");  // ← ADD
  const { school_id } = useSelector((state) => state.globalState);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

// ── Debounce search ──
useEffect(() => {
  const timer = setTimeout(() => setDebouncedSearch(searchText), 400);
  return () => clearTimeout(timer);
}, [searchText]);

useEffect(() => {
  setCurrentPage(1);
}, [debouncedSearch, sortValue]);  

const navigate = useNavigate();

  const sortOptions = [
    { label: "Name : A - Z", value: "A-Z" },
    { label: "Name : Z - A", value: "Z-A" },
    { label: "Newest First", value: "Newest" },
    { label: "Oldest First", value: "Oldest" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortRef.current && !sortRef.current.contains(e.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  
// Keep a ref to track if sort/search changed
const prevSortRef = useRef(sortValue);
const prevSearchRef = useRef(debouncedSearch);

useEffect(() => {
  if (openViewDepartments) return;

  const sortChanged = prevSortRef.current !== sortValue;
  const searchChanged = prevSearchRef.current !== debouncedSearch;

  prevSortRef.current = sortValue;
  prevSearchRef.current = debouncedSearch;

  // If sort or search changed, reset page to 1 and fetch page 1
  if (sortChanged || searchChanged) {
    setCurrentPage(1);
    dispatch(fetchDepartmentActions(token, sortValue || undefined, {
      page: 1,           // explicitly use 1, not stale currentPage
      search: debouncedSearch.trim() || undefined,
      school_id:school_id
    }));
    return;
  }

  // Otherwise fetch current page normally
  dispatch(fetchDepartmentActions(token, sortValue || undefined, {
    page: currentPage,
    search: debouncedSearch.trim() || undefined,
    school_id:school_id
  }));
}, [dispatch, token, sortValue, currentPage, debouncedSearch, openViewDepartments, school_id]);

  // Columns */
  const columns = [
    {
      key: "department",
      title: "Department",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
          <span>{value}</span>
        </div>
      ),
    },
    {
      key: "noOfTeachers",
      title: "No. of Teachers",
      sortable: false,
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
    {
      key: "departmentCourses",
      title: "Department Courses",
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
    {
      key: "action",
      title: "Action",
      headerStyle: { textAlign: "center" },
      render: (_, row, __, isHovered) => (
        <div style={{ display: "flex", alignItems: "center",justifyContent:"center", gap: 10 }}>
          <span
            style={{
              color: "#0068FF",
              fontSize: 13.5,
              fontWeight: 500,
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              // navigate(`/dashboard/advisors/students`, {
              //   state: { advisor: row },
              // });
              setSelectedDepartment({ subject_id: row.subject_id, subject_name: row.department });
              setopenViewDepartments(true);
            }}
          >
            View Department
          </span>
        </div>
      ),
    },
  ];

  const departmentData = (Array.isArray(departments) ? departments : []).map((dept, index) => ({
    key: index + 1,
    subject_id:dept.subject_id,
    department: dept.subject_name,
    noOfTeachers: `${dept.teachers_count} ${dept.teachers_count <= 1 ? "Teacher" : "Teachers"}`,
    departmentCourses: `${dept.department_courses}  ${dept.department_courses <=1 ? " Course" : " Courses"}`,
  }));
   const filteredData = departmentData
  // .filter((s) => {
  //   const matchSearch =
  //     s?.department?.trim().toLowerCase().includes(searchText.trim().toLowerCase()) 
  //   return matchSearch;
  // }).sort((a, b) => {
  //   if (sortValue === "a-z") {
  //     return a.department.localeCompare(b.department);
  //   } else if (sortValue === "z-a") {
  //     return b.department.localeCompare(a.department);
  //   } else if (sortValue === "newest") {
  //     return new Date(b.created_at) - new Date(a.created_at);
  //   } else if (sortValue === "oldest-first") {
  //     return new Date(a.created_at) - new Date(b.created_at);
  //   } else {
  //     return 0;
  //   }
  // });


  const navigateBack = () => {
    setopenViewDepartments(false);
      setSelectedDepartment(null);
  };

  const total = filteredData.length === 0 ? 0 : (totalCount ?? 0);
  return (
    <>
      <div>
        {openViewDepartments ? (
          <ViewDepartment navigateBack={navigateBack} subjectName={selectedDepartment?.subject_name} subjectId={selectedDepartment?.subject_id} />
        ) : (
          <>
            <BackButton handleClick={() => navigate("/dashboard/home")} buttonName="Back" />

            {/* Toolbar */}
            <div className="department-toolbar">
              <div className="department-left-tools">
                <h3>Departments</h3>
                {/* Search */}
                <SearchComponent
                search={search_bar}
                  searchPlaceholder="Search Department"
                  value={searchText}
                  onchange={(e) => setSearchText(e.target.value)}
                />
              {/*   <div className="search-bar">
                  <img src={search_bar} alt="search-bar" />
                  <div className="search-divider"></div>
                  <input
                    placeholder="Search Department"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div> */}
              </div>

              <div className="department-right-tools">
                {/* Sort button */}
               <div style={{ position: "relative" }} ref={sortRef}>
                  <button className="sort-button" onClick={() => setShowSortMenu((prev) => !prev)}>
                    <img src={sort} alt="sort" />
                    Sort
                  </button>

                  {showSortMenu && (
                    <div className="sort-menu">
                      {sortOptions.map((option) => (
                        <div className="sort-options"
                          key={option.value}
                          onClick={() => { setSortValue(option.value); setShowSortMenu(false); }}
                          style={{
                            color: sortValue === option.value ? "#0068FF" : "#374151",
                            fontWeight: sortValue === option.value ? 600 : 400,
                            background: sortValue === option.value ? "#f0f7ff" : "#fff",
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                          onMouseLeave={(e) => e.currentTarget.style.background = sortValue === option.value ? "#f0f7ff" : "#fff"}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* DataTable */}
            <div>
               {isMobile ? (
                <ResponsiveCardsDepartment
                  data={filteredData}
                  onViewDepartment={(item) => {
                    setSelectedDepartment({
                      subject_id: item.subject_id,
                      subject_name: item.department,
                    });
                    setopenViewDepartments(true);
                  }}
                />
              ) : (
                <DataTableListing
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="key"
                  pagination={
                    total > 12
                      ? {
                          currentPage: currentPage,
                          total: total,
                          pageSize: 12,
                          onChange: (page) => setCurrentPage(page),
                        }
                      : false
                  }
                  checkable={false}
                  loading={loading}
                  emptyText="No Department found"
                  bordered={false}
                  size="default"
                  rowHoverColor="#F7F7F7"
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Departments;
